import React from 'react';
import { ProgressBar } from 'react-bootstrap';

const Progress = ({ 
    now = 0, 
    min = 0, 
    max = 100, 
    label, 
    variant = 'primary', 
    striped = false, 
    animated = false,
    isMobile = false, 
    isTablet = false, 
    isDesktop = false, 
    style, 
    className,
    ...props 
}) => {
    return (
        <ProgressBar 
            now={now} 
            min={min} 
            max={max} 
            label={label}
            variant={variant}
            striped={striped}
            animated={animated}
            className={className} 
            style={style}
            {...props}
        />
    );
};

export default Progress;

